document.addEventListener("DOMContentLoaded", () => {
    const videoElement = document.getElementById("hero-video");
    const videoFallback = document.getElementById("hero-video-fallback");
    if (!videoElement) return;

    (async () => {
        try {
            videoElement.load(); // Force Chrome to pick the right <source>
            await videoElement.play();
        } catch (error) {
            if (error.name === "NotAllowedError" || error.name === "AbortError") {
                console.log("Autoplay blocked — possibly browser policy or Low Power Mode ⚡️");
                videoElement.remove();
                if (videoFallback) videoFallback.style.display = "block";
            } else {
                console.error("Video playback failed:", error);
            }
        }
    })();
});